// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobileContent {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #FFF1E6;
}
.mobileContent .img {
  height: calc(100vh - 375px);
  width: 95%;
}
.mobileContent .mainContent {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 1rem;
  background-color: white;
  border-radius: 3rem 3rem 0 0;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.grid {
  width: 100%;
  height: 100vh;
  background-color: #F4F7FB;
}
@media (max-width: 991px) {
  .grid {
    height: 100%;
  }
}
.grid .rightGrid {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
}
.grid .rightGrid .form {
  display: flex;
  align-items: start;
  justify-content: center;
  flex-direction: column;
  padding: 1rem;
  width: 100%;
  max-width: 420px;
  text-align: center;
}
.grid .rightGrid .form .link {
  width: fit-content;
  text-decoration: none;
  cursor: pointer;
}
.grid .rightGrid .form .logo {
  width: 100%;
  display: flex;
  justify-content: center;
}
@media (max-width: 991px) {
  .grid .rightGrid .form .logo {
    display: none;
  }
}
.grid .rightGrid .form .forgetContainer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.grid .rightGrid .form .forgetContainer > :first-child {
  cursor: pointer;
}
.grid .leftGrid {
  width: 100%;
  display: grid;
  align-items: center;
  justify-items: center;
  background-color: #FFF1E6;
}
.grid .leftGrid .img {
  width: 70%;
}

.logo {
  width: 100%;
  display: flex;
  justify-content: center;
}
@media (max-width: 991px) {
  .logo {
    display: none;
  }
}

.link {
  text-decoration: none;
  cursor: pointer;
}

.termsContainer {
  display: flex;
  justify-content: center;
  text-align: center;
  width: 100%;
}
.termsContainer .terms {
  font-size: 0.7rem;
  width: 85%;
}
.termsContainer .register {
  font-weight: bold;
  cursor: pointer;
  color: #005B96;
}`, "",{"version":3,"sources":["webpack://./src/pages/Auth/Login/login.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EAEA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAAJ;AAEI;EACI,2BAAA;EACA,UAAA;AAAR;AAGI;EACI,eAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,4BAAA;EACA,sCAAA;AADR;;AAKA;EACI,WAAA;EACA,aAAA;EACA,yBAAA;AAFJ;AAII;EALJ;IAMQ,YAAA;EADN;AACF;AAGI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;AADR;AAIQ;EACI,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAFZ;AAKY;EACI,kBAAA;EACA,qBAAA;EACA,eAAA;AAHhB;AAMY;EACI,WAAA;EACA,aAAA;EACA,uBAAA;AAJhB;AAMgB;EALJ;IAMO,aAAA;EAHjB;AACF;AAMY;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAJhB;AAMgB;EACI,eAAA;AAJpB;AAUI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;AARR;AAWQ;EACI,UAAA;AATZ;;AAeA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;AAZJ;AAcI;EALJ;IAMQ,aAAA;EAXN;AACF;;AAcA;EACI,qBAAA;EACA,eAAA;AAXJ;;AAcA;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAXJ;AAaI;EACI,iBAAA;EACA,UAAA;AAXR;AAcI;EACI,iBAAA;EACA,eAAA;EACA,cAAA;AAZR","sourcesContent":[".mobileContent {\n    width: 100%;\n    height: 100%;\n    display: flex;\n\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background-color: #FFF1E6;\n\n    .img {\n        height: calc(100vh - 375px);\n        width: 95%;\n    }\n\n    .mainContent {\n        position: fixed;\n        bottom: 0;\n        width: 100%;\n        padding: 1rem;\n        background-color: white;\n        border-radius: 3rem 3rem 0 0;\n        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n    }\n}\n\n.grid {\n    width: 100%;\n    height: 100vh;\n    background-color: #F4F7FB;\n\n    @media (max-width: 991px ) {\n        height: 100%;\n    }\n\n    .rightGrid {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: white;\n\n\n        .form {\n            display: flex;\n            align-items: start;\n            justify-content: center;\n            flex-direction: column;\n            padding: 1rem;\n            width: 100%;\n            max-width: 420px;\n            text-align: center;\n\n\n            .link {\n                width: fit-content;\n                text-decoration: none;\n                cursor: pointer;\n            }\n\n            .logo {\n                width: 100%;\n                display: flex;\n                justify-content: center;\n\n                @media (max-width: 991px ) {\n                   display: none;\n                }\n            }\n\n            .forgetContainer {\n                width: 100%;\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n\n                >:first-child {\n                    cursor: pointer;\n                }\n            }\n        }\n    }\n\n    .leftGrid {\n        width: 100%;\n        display: grid;\n        align-items: center;\n        justify-items: center;\n        background-color: #FFF1E6;\n\n\n        .img {\n            width: 70%;\n        }\n    }\n}\n\n\n.logo {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n\n    @media (max-width: 991px ) {\n        display: none;\n    }\n}\n\n.link {\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.termsContainer {\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n\n    .terms {\n        font-size: 0.7rem;\n        width: 85%;\n    }\n\n    .register {\n        font-weight: bold;\n        cursor: pointer;\n        color: #005B96;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
